var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { autoinject } from "aurelia-framework";
import { Api } from "../../constants/modules/api.constants";
import { RequestClient } from "../basics/request-client.service";
import { toNative } from "../../utilities/promise-utils";
var ApiSettingClientService = /** @class */ (function () {
    function ApiSettingClientService(requestClient) {
        this.requestClient = requestClient;
    }
    ApiSettingClientService.prototype.saveApiSetting = function (persistApiSettingRequest) {
        return toNative(this.requestClient.post(Api.ApiSettings.SaveApiSetting, {}, persistApiSettingRequest));
    };
    ApiSettingClientService.prototype.getApiSetting = function (apiSettingId) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.requestClient.get(Api.ApiSettings.GetApiSetting, { apiSettingId: apiSettingId }).then(function (x) {
                resolve(x.apiSetting);
            }, function () { });
        });
    };
    ApiSettingClientService.prototype.delete = function (apiSettingId) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.requestClient.post(Api.ApiSettings.DeleteApiSetting, {}, { apiSettingId: apiSettingId }).then(function (x) {
                resolve(x);
            }, function () { });
        });
    };
    ApiSettingClientService = __decorate([
        autoinject(),
        __metadata("design:paramtypes", [RequestClient])
    ], ApiSettingClientService);
    return ApiSettingClientService;
}());
export { ApiSettingClientService };
